import { EllipsisOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { Popover, Space } from 'antd';
import { getStoreCount, StoreScopesPreview } from 'components/StoreScopes';
import { memo } from 'react';
import { useTranslate } from '@tolgee/react';

const Ellipsis = styled(EllipsisOutlined)`
  border-radius: 50%;
  background-color: #d6e8ff;
  padding: 2px;
  font-size: 10px;
  color: rgba(0, 0, 0, 0.4);
`;

export const PreviewWrapper = styled.div`
  margin: -12px -16px;
  max-height: 280px;
  overflow: auto;
  > div {
    background: #fff;
  }
`;

export interface AssignReceptionConfColumnProps
  extends Pick<
    StoreHomeV2.RoleWithDepartment,
    'assignConversation' | 'assignConversationConfig' | 'isAdmin' | 'adminStoreScopes'
  > {}

function AssignReceptionConfColumn(props: AssignReceptionConfColumnProps) {
  const { isAdmin, adminStoreScopes, assignConversation, assignConversationConfig } = props;

  const { t } = useTranslate();

  if (!isAdmin && !assignConversation) {
    return <div>{t('department.不予分配')}</div>;
  }

  const scopes = (isAdmin ? adminStoreScopes : assignConversationConfig.platformStoreScopes) || [];

  const count = getStoreCount(scopes);

  return (
    <Popover
      getPopupContainer={(trigger) => trigger}
      content={
        <PreviewWrapper>
          <StoreScopesPreview value={scopes} showTitle={false} showSearch={false} />
        </PreviewWrapper>
      }
    >
      <Space size={6} align="center">
        {isAdmin
          ? t('department.监督x店铺', { x: count })
          : t('department.智能分配x店铺', { x: count })}
        <Ellipsis />
      </Space>
    </Popover>
  );
}

export default memo(AssignReceptionConfColumn);
